import { FC } from 'react';

/** @deprecated */
const WrenchIcon: FC = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.956055" y="1.34375" width="25" height="25" rx="12.5" stroke="#1C85E8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6571 13.7066C19.7843 12.5789 20.002 10.8835 19.313 9.53699L17.4881 11.3564H16.0198V9.80872L17.7995 7.98324C16.4535 7.29482 14.7405 7.51309 13.6133 8.63968C12.4868 9.76628 12.2569 11.4567 12.9459 12.8027L7.52952 18.2146C7.09905 18.6445 7.09574 19.3429 7.52676 19.7728C7.95722 20.2038 8.65391 20.2038 9.08437 19.7728L14.4947 14.3614C15.8412 15.0504 17.5311 14.8326 18.6571 13.7066V13.7066Z"
      stroke="#1C85E8"
      strokeLinejoin="round"
    />
  </svg>
);

export default WrenchIcon;
